export default {
      id: "logo_go_color-usage",
      viewBox: "0 0 94 30",
      url: __webpack_public_path__ + "sprite.svg#logo_go_color",
      toString: function () {
        return this.url;
      }
    }